<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0 my-2"
    >
    
    
        <processing-news-upload>
          <template v-slot:activator="{ on: dialog}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                  <span class="subtitle-1 font-weight-bold primary--text" style="display:inline-block;">Novidade!</span> 
                  <v-icon v-on="{...dialog, ...tooltip}">mdi-arrow-down-drop-circle</v-icon>
                  <pre> <span class="subtitle-1">Agora você pode compactar suas imagens (.zip)</span> </pre>
              </template>
              <span>Clique aqui para saber como usar</span>
            </v-tooltip>
          </template>
        </processing-news-upload>

      <v-card
        id="processing-dropzone"
        @dragover.prevent.stop="onDragOver"
        outlined
        width="100%"
        @click="onImageInputClick"
        @dragenter.passive.stop="onDragEnter"
        @dragexit.stop="onDragExit"
        @dragleave.stop="onDragLeave"
        @drop="onDrop"
        :loading="isEvaluatingImages"
        class="dropzone"
      >
        <v-card-text>
          <v-row
            justify="center"
            align="center"
            class="fill-height ma-0"
          >
            <input
              id="file-upload-input"
              type="file"
              accept="image/*"
              ref="image-input"
              @change="onImageInputChange"
              class="image-input"
              :multiple="processingTypeIsFP"
            >
            <empty-state
              :color="isDragging ? 'accent' : ''"
            >
              <template v-slot:icon>
                <v-icon :color="isDragging ? 'accent' : ''">mdi-cloud-upload</v-icon>
              </template>
              <template v-slot:description>
                {{imageInputDescription}}
              </template>
              <template v-slot:overlay>
                <v-overlay
                  :value="isDragging"
                  absolute
                  opacity=".8"
                >
                  <span class="subtitle-1 font-weight-bold white--text">Solte os arquivos para adicioná-los ao upload</span>
                </v-overlay>
              </template>
            </empty-state>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      justify="center"
      align="center"
      class="ma-0 my-2"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-row
          align="center"
          justify="space-between"
          class="ma-0"
        >
          <v-card-title class="title">Upload de imagens</v-card-title>
          <transition name="error">
            <div class="error--text" v-if="this.$v.$dirty && this.$v.uploadedImages.$invalid">
              {{uploadedImagesError}}
            </div>
            <div class="light-blue--text" v-if="isFinishingStream">
              Estamos finalizando o upload, por favor aguarde.
            </div>
            <div class="error--text" v-if="isDeletingImage">
              Estamos excluindo sua imagem, por favor aguarde.
            </div>
          </transition>
          <div class="body-1 ma-4">
            <b>Arquivos Carregados {{ uploadedImages.length }}/{{ fullImagesList.length }}</b>
          </div>
        </v-row>
        <v-divider></v-divider>
        <v-card-text>
          <v-row
            justify="space-between"
            align="center"
            class="ma-0"
          >
            <v-col
              cols="11"
            >
              <v-progress-linear
                :indeterminate="isFinishingStream"
                :query="isFinishingStream"
                :value="imagesUploadProgress"
                rounded
              >
              </v-progress-linear>
            </v-col>
            <v-col
              cols="1"
            >
              <div>{{imagesUploadProgress}}%</div>
            </v-col>
          </v-row>
          <v-row
            v-if="isLoadingImages"
            justify="center"
            align="center"
            class="ma-0 my-10"
          >
            <v-progress-circular
              indeterminate
              color="accent"
            >
            </v-progress-circular>
            <div class="caption ml-4">Carregando imagens...</div>
          </v-row>
          <v-row
            v-else
            align="center"
            class="ma-0"
          >
            <v-col
              v-for="img in currImagesPage"
              :key="img.name"
              cols="6"
              xs="3"
              sm="3"
              md="4"
              lg="4"
              xl="4"
            >
              <v-card
                hover
                class="pa-2 image-card"
              >
                <v-row
                  justify="space-between"
                  align="center"
                  class="ma-0 flex-nowrap"
                >
                  <v-icon class="px-1" color="red">mdi-image</v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="body-2 px-1 text-break text-truncate">{{img.name}}</span>
                    </template>
                    <span>{{img.name}}</span>
                  </v-tooltip>
                  <transition name="fade" mode="out-in">
                    <v-icon
                      v-if="checkImageUploadFinished(img)"
                      color="success"
                      class="px-1"
                    >
                      mdi-check-circle
                    </v-icon>
                    <v-progress-circular
                      v-else
                      :indeterminate="img.uploadStarted && img.uploadProgress === 0"
                      :value="img | getCurrImgProgress"
                      color="primary"
                      class="px-1"
                      width="3"
                    >
                      <span class="upload-progress__text">{{img | getCurrImgProgress}}</span>
                    </v-progress-circular>
                  </transition>
                </v-row>
                <v-btn
                  v-if="!isUploadingImages && !isDeletingImage && !_processingIsReadOnly"
                  @click="() => {removeImage(img)}"
                  small
                  icon
                  absolute
                  color="error"
                  elevation="0"
                  class="delete-image-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
          <v-row
            v-if="maxPage > 1"
            align="center"
            class="ma-0 my-2"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  @on="on"
                  :disabled="currPageIdx <= 0"
                  @click="() => {setPage(0)}"
                  icon
                  class="mx-2"
                >
                  <v-icon>mdi-page-first</v-icon>
                </v-btn>
              </template>
              <span>Primeira página</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  @on="on"
                  :disabled="currPageIdx <= 0"
                  @click="lastPage"
                  icon
                  class="mx-2"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>Página anterior</span>
            </v-tooltip>
            <v-spacer/>
            <span class="subtitle-2">Página: {{currPageIdx + 1}}/{{maxPage}}</span>
            <v-spacer/>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="nextPageIsDisabled"
                  @click="nextPage"
                  @on="on"
                  class="mx-2"
                  icon
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <span>Próxima página</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  @on="on"
                  :disabled="nextPageIsDisabled"
                  @click="() => {setPage(maxPage - 1)}"
                  icon
                  class="mx-2"
                >
                  <v-icon>mdi-page-last</v-icon>
                </v-btn>
              </template>
              <span>Última página</span>
            </v-tooltip>
          </v-row>
          <v-row
            align="center"
            class="ma-0"
          >
            <v-btn
              id="start-upload-btn"
              color="warning"
              outlined
              block
              :loading="isEvaluatingImages"
              @click="startUpload"
              :disabled="isUploadingImages || toUploadImages.length === 0 || minLengthImages"
            >
              Começar Upload
              <template v-slot:loader>
                <span>Verificando imagens {{intImagesEvaluated}}/{{intImagesToEvaluate}}</span>
              </template>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      v-if="hasFlightLog"
      justify="center"
      align="center"
      class="ma-0 my-2"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-row
          align="center"
          justify="space-between"
          class="ma-0"
        >
          <v-card-title class="title">Upload Log de Voo</v-card-title>
          <transition name="error">
            <div
              v-if="this.$v.$dirty && this.$v.isFlightLogUploaded.$invalid"
              class="error--text"
            >
              {{isFlightLogUploadedError}}
            </div>
          </transition>
        </v-row>
        <v-card-text>
          <v-row
            justify="space-between"
            align="center"
            class="ma-0"
          >
            <v-col
              cols="11"
            >
              <v-progress-linear
                :value="flightLogUploadProgress"
                rounded
              >
              </v-progress-linear>
            </v-col>
            <v-col
              cols="1"
              align-self="end"
            >
              <div>{{flightLogUploadProgress}}%</div>
            </v-col>
          </v-row>
          <v-row
            class="ma-0"
          >
            <v-file-input
              v-model="flightLogInput"
              :label="flightLogInputLabel"
              outlined
              clearable
              @change="addFlightLogToUpload"
            >
            </v-file-input>
          </v-row>
          <v-row
            v-if="!_processingIsReadOnly"
            align="center"
            class="ma-0"
          >
            <v-btn
              color="warning"
              outlined
              block
              :loading="isUploadingFlightLog"
              @click="startUploadFlightLog"
              :disabled="!flightLogFile || isFlightLogUploaded"
            >
              Começar Upload
              <template v-slot:loader>
                <span>Carregando log de voo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      v-if="hasGcp"
      justify="center"
      align="center"
      class="ma-0 my-2"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-row
          align="center"
          justify="space-between"
          class="ma-0"
        >
          <v-card-title class="title">Upload Pontos de Controle</v-card-title>
          <transition name="error">
            <div
              v-if="this.$v.$dirty && this.$v.isGcpUploaded.$invalid"
              class="error--text"
            >
              {{isGcpUploadedError}}
            </div>
          </transition>
        </v-row>
        <v-card-text>
          <v-row
            justify="space-between"
            align="center"
            class="ma-0"
          >
            <v-col
              cols="11"
            >
              <v-progress-linear
                :value="gcpUploadProgress"
                rounded
              >
              </v-progress-linear>
            </v-col>
            <v-col
              cols="1"
              align-self="end"
            >
              <div>{{gcpUploadProgress}}%</div>
            </v-col>
          </v-row>
          <v-row
            class="ma-0"
          >
            <v-file-input
              v-model="gcpInput"
              label="Clique aqui e insira um arquivo do tipo .txt"
              outlined
              clearable
              @change="addGcpToUpload"
            >
            </v-file-input>
          </v-row>
          <v-row
            v-if="!_processingIsReadOnly"
            align="center"
            class="ma-0"
          >
            <v-btn
              color="warning"
              outlined
              block
              :loading="isUploadingGcp"
              @click="uploadGcp"
              :disabled="!gcpFile || isUploadingGcp || isGcpUploaded"
            >
              Começar Upload
              <template v-slot:loader>
                <span>Carregando gcp...</span>
              </template>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row
      v-if="mustShowAutoProcessing"
      justify="start"
      align="center"
      class="ma-0 my-2"
    >
      <v-checkbox
        label="Começar processamento ao finalizar o upload"
        v-model="mustStartProcessingOnFinish"
      />
      <v-spacer/>

      <v-dialog
        v-model="dialog2"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            Preview
          </v-card-title>
          <v-card-text>
            <v-progress-circular
              v-if="!imgCoords && loadImgCoords"
              indeterminate
              color="primary"
              :size="70"
              :width="7"        
            ></v-progress-circular>              
            <v-img
              v-if="imgCoords"
              :src="imgCoords"
              max-width="600"
              max-height="600"        
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="warning"
              block
              @click="closePreviewCoordsVoo"
            >
              Close preview
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <!-- <v-btn
        @click="closePreviewCoordsVoo"
        color="warning"
        v-if="imgCoords"
      >
        Close Preview
      </v-btn>         -->
      <v-btn
        v-if="!hasFlightLog && !isZipFileSelected"
        @click="geoTagCoordsGetImg"
        color="primary"
        :disabled="isUploadingImages || toUploadImages.length === 0"
      >
        Preview coordenadas do voo
      </v-btn>      
    </v-row>
    <!-- <v-row
      align="center"
      justify="center"
      class="actions my-10"
      v-if="loadImgCoords"
    >
      <v-progress-circular
        v-if="!imgCoords && loadImgCoords"
        indeterminate
        color="primary"
        :size="70"
        :width="7"        
      ></v-progress-circular>      
      <v-img
        v-if="imgCoords"
        :src="imgCoords"
        max-width="600"
        max-height="600"        
        aspect-ratio="1"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>      
    </v-row> -->
    <v-row
      align="center"
      justify="start"
      class="actions my-10"
    >
      <v-btn
        @click="onLastClick"
        color="accent"
        outlined
      >
        Voltar
      </v-btn>
      <v-spacer/>
      <v-btn
        v-if="!mustStartProcessingOnFinish"
        @click="onNextClick"
        color="primary"
        :disabled="!isUploadFinished"
      >
        Próximo
      </v-btn>
    </v-row>

    <upload-issue-dialog :show="issueDialog" :content="issueContent" :qttData="qttData" @close="issueDialog = false"/>
  </v-container>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import EmptyState from "../../Helpers/EmptyState"
  import {mapActions, mapGetters} from "vuex"
  import {
    GET_ID_PROCESSING,
    GET_PROCESSING_DATA,
    GET_PROCESSING_IS_READ_ONLY,
  } from "../../../store/modules/processing"
  import {gt, gte, isEmpty, isEqual, isNull, isUndefined} from "lodash/lang"
  import {
    CAMERA_TYPES,
    GEOREFERENCE_TYPES,
    PROCESSING_STEPS,
    PROCESSING_TYPES,
  } from "../../../helpers/processings/constants"
  import {DIALOG_TYPES, DialogOptions} from "../../../helpers/dialogs"
  import UploadFileHolder from "../../../helpers/upload/file-holder"
  import {
    calculateProcessingData, confirmTillingProcessing,
    getUploadedFlightLog,
    getUploadedGcp,
    listUploadedImages, startProcessing,
    postCoordsToImages
  } from "../../../api/api-project"
  import {
    GET_NON_UPLOADED_FILES,
    REMOVE_NON_UPLOADED_FILE,
    SET_NON_UPLOADED_FILES,
  } from "../../../store/modules/uploader"
  import {ProcessingStepperEventBus} from "../../../helpers/processings/events"
  import {flightLogUploaderMixin, gcpUploaderMixin, ImageUploaderMixin} from "../../../helpers/upload/mixins"
  import {UploaderEventBus} from "../../../helpers/upload/events"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import ProcessingNewsUpload from "./ProcessingNewsUpload"
  import UploadIssueDialog from '../../Helpers/Dialogs/UploadIssueDialog.vue'

  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  import Vue from "vue";
  Vue.use(Loading);

  import EXIF from "exif-js"

  const START_PROCESSING_TIME_MS = 100

  const ProcessingLastStep = Symbol.for("ProcessingLastStep")
  const ProcessingNextStep = Symbol.for("ProcessingNextStep")
  const ProcessingSetStep = Symbol.for("ProcessingSetStep")

  export default {
    name: "ProcessingUpload",
    mixins: [validationMixin, ImageUploaderMixin, flightLogUploaderMixin, gcpUploaderMixin],
    inject: {NextStep: ProcessingNextStep, LastStep: ProcessingLastStep, SetStep: ProcessingSetStep},
    components: {EmptyState, ProcessingNewsUpload, UploadIssueDialog},
    data: () => ({
      isDirty: false,
      isDragging: false,

      hasImageError: false,
      hasFlightLogError: false,

      mustStartProcessingOnFinish: false,

      // Pagination
      imagesPerPage: 18,
      currPageIdx: 0,
      currPageImages: [],
      isUploadingImages: false,
      toUploadImages: [],
      issueDialog: false,
      issueContent: "invalid-files",
      qttData: null,
      zipReadError: false,
      loader: null,
      imgCoords: null,
      loadImgCoords: false,
      dialog2: false
    }),
    validations() {
      return {
        uploadedImages: {
          minLength: function () {
            if (this.processingTypeIsFP) {
              // return this.uploadedImages.length >= 8
              if (!this.fullImagesList[0].name.endsWith('.zip')){
                return this.uploadedImages.length >= 8
              } else {
                return this.uploadedImages.length === 1
              }            
            } else {
              return this.uploadedImages.length === 1
            }
          },
        },
        ...((this.hasFlightLog) && {
          isFlightLogUploaded: {
            complete: function () {
              return this.isFlightLogUploaded
            },
          },
        }),
        ...((this.hasGcp) && {
          isGcpUploaded: {
            complete: function () {
              return this.isGcpUploaded
            },
          },
        }),
      }
    },
    methods: {
      onNextClick() {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.NextStep()
      },
      onLastClick() {
        if (this.processingTypeIsFP)
          this.LastStep()
        else
          this.SetStep(PROCESSING_STEPS.BASIC)
      },
      // Image Upload control
      onImageInputClick() {
        if (!this.canUpload) return
        this.$refs["image-input"].click()
      },
      onImageInputChange(event) {        
        this.hasImageError = false
        this.addImagesToUpload(Array.from(event.target.files))
      },

      verifyImagensLengthExceeded(files) {
        if (this.isMultispectral) {
          if (isEqual(this.$subsMng.subscriptionPlanConfig["int_max_images_per_multispectral_processing"], -1)) return true
          if (gt((this.fullImagesList.length + files.length), this.$subsMng.subscriptionPlanConfig["int_max_images_per_multispectral_processing"])) {
            this.$dialog(new DialogOptions({
              width: "650px",
              type: DIALOG_TYPES.BUSINESS_ONLY,
              content: `No seu plano atual o número máximo para processamento multiespectral é de <br/><b>${this.$subsMng.subscriptionPlanConfig["int_max_images_per_multispectral_processing"]} imagens</b>.<br/>
            Atualize seu plano e ganhe mais vantagens.`
            }))
            return false
          }
        } else {
          if (isEqual(this.$subsMng.subscriptionPlanConfig["int_max_images_per_rgb_processing"], -1)) return true
          if (gt((this.fullImagesList.length + files.length), this.$subsMng.subscriptionPlanConfig["int_max_images_per_rgb_processing"])) {
            this.$dialog(new DialogOptions({
              width: "650px",
              type: DIALOG_TYPES.BUSINESS_ONLY,
              content: `No seu plano atual o número máximo para processamento rgb é de <br/><b>${this.$subsMng.subscriptionPlanConfig["int_max_images_per_rgb_processing"]} imagens</b>.<br/>
            Atualize seu plano e ganhe mais vantagens.`
            }))

            return false
          }
        }
        return true
      },
      addImagesToUpload(files) {
        if (isEmpty(files) || this.isUploadingImages) return
        if (this.processingTypeIsFP) {
          if (!this.verifyImagensLengthExceeded(files)) return
          const checkGeoTag = this.processingTypeIsFP && !this.hasFlightLog
          this.addImagesFullProcessing(files, this.isMultispectral, checkGeoTag, this.hasFlightLog)
        } else {
          this.addImagesTilling(files[0])
        }
      },
      addFlightLogToUpload(file) {
        let abGeoreferenceType = this._processingData["ab_georeference_type"]
        this.addFlightLog(file, abGeoreferenceType)
      },

      startUploadFlightLog() {
        let abGeoreferenceType = this._processingData["ab_georeference_type"]
        this.uploadFlightLog(abGeoreferenceType)
      },

      onUploadFinished() {
        if (this.$subsMng.subscriptionPlanConfig["bl_charge_processing"]) return
        if (this.hasGcp && this.$subsMng.subscriptionPlanConfig["bl_charge_gcp"]) return
        if (!(this.isUploadFinished && this.mustStartProcessingOnFinish)) return

        setTimeout(() => {
          if (this.processingTypeIsTilling) {
            const data = {
              zipReadError: this.zipReadError
            }
            calculateProcessingData(this.$apiAuth.getAuthToken(), this._idProcessing, data)
              .then(() => {
                confirmTillingProcessing(this.$apiAuth.getAuthToken(), this._idProcessing)
                  .then(() => {
                    this.$router.push("/app/")
                  })
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "O arquivo zip superou a quantidade máxima de imagens permitida pelo seu plano",
                  type: NOTIFICATION_TYPES.ERROR,
                }))
                this.$router.push("/app/processing-list")                
              })
          } else {
            const data = {
              zipReadError: this.zipReadError
            }
            calculateProcessingData(this.$apiAuth.getAuthToken(), this._idProcessing, data)
              .then(() => {
                startProcessing(this.$apiAuth.getAuthToken(), this._idProcessing)
                  .then(() => {
                    this.$router.push("/app/")
                  })
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "O arquivo zip superou a quantidade máxima de imagens permitida pelo seu plano",
                  type: NOTIFICATION_TYPES.ERROR,
                }))
                this.$router.push("/app/processing-list")
              })
          }
        }, START_PROCESSING_TIME_MS)
      },

      // Image Drop files section events
      onDrop(event) {
        event.preventDefault()
        this.hasImageError = false
        this.isDirty = false

        if (!this.canUpload) {
          return
        }

        this.isDragging = false

        if (!event.dataTransfer.items) {
          return
        }

        const fileList = this.getFilesFromDataTransfer(event.dataTransfer)
        this.addImagesToUpload(fileList)        
      },
      closePreviewCoordsVoo () {
        this.dialog2 = false
        this.loadImgCoords = false
        this.imgCoords = null
      },
      async geoTagCoordsGetImg() {
        if (isEmpty(this.toUploadImages)) return
        this.loadImgCoords = true        
        this.loader = this.$loading.show({
          container: null,
          canCancel: false,
          backgroundColor: "#000",
          color: "#fff",
          opacity: 0.5,
          loader: "spinner",
          onCancel: this.onCancel,
        });
        try {
          if(this.toUploadImages[0].isZip) {
            console.log("Is .zip")
            this.$zipLib.workerScriptsPath = "/js/";
            let entries = await new this.$zipLib.ZipReader(new this.$zipLib.BlobReader(this.toUploadImages[0])).getEntries()
            if (entries && entries.length) {
              const validFormats = ['jpg', 'jpeg', 'gif', 'tiff', 'tif']
              for (var i = 0; i < entries.length; i++) {
                var entry = entries[i].filename.split('.')
                // var fileNameImg = entry[0]
                var extension = entry.pop()
                if (i == 0 && entries[i].directory) {
                  continue
                }
                if (!validFormats.includes(extension.toLowerCase())) {
                  this.loadImgCoords = false
                  this.$notify(new NotificationOptions({
                    message: "Parece haver algo de errado com seu arquivo .zip",
                    type: NOTIFICATION_TYPES.WARNING,
                  }))                                
                  return
                }
              }

              const listCoordsImages = await new Promise((resolve, reject) => { 
                try {
                  let temArrayCoords = [] 
                  for (var j = 0; j < entries.length; j++) {
                    const tags = new Promise((resolve, reject) => {  
                      const blobWriter = new this.$zipLib.BlobWriter();
                      console.log('Lendo arquivo: ', entries[j].filename)
                      var entry_name = entries[j].filename.split('/')
                      var filename = entry_name.pop()        
                      entries[j].getData(blobWriter).then((blobFile) => {
                        EXIF.getData(blobFile, function(err, tags) {
                          window.decimalCoords = function(coords, ref) {
                            // console.log('THIS ', this)
                            let decimal_degrees = coords[0] + coords[1] / 60 + coords[2] / 3600
                            if (ref == "S" || ref == "W"){
                                decimal_degrees = -decimal_degrees
                            }
                            return decimal_degrees
                          }                       
                          if (err) reject(err);
                          else {
                            let latitude = window.decimalCoords(this.exifdata.GPSLatitude, this.exifdata.GPSLatitudeRef)
                            let longitude = window.decimalCoords(this.exifdata.GPSLongitude, this.exifdata.GPSLongitudeRef)
                            let altitude = this.exifdata.GPSAltitude
                            tags = {'imagem': filename, 'longitude':longitude, 'latitude': latitude, 'altitude': altitude}
                            resolve(tags);
                          }
                        });
                      })
                    }); 
                    temArrayCoords.push(tags)
                  }
                  resolve(temArrayCoords)
                } catch (error) {
                  reject(error)
                }        
              })
              Promise.all(listCoordsImages).then((values) => {   
                let json_str_coords = JSON.stringify(values)
                console.log('JSON_ARRAY_COORDS >> ', json_str_coords)
                // this.submitCoordsImages(json_str_coords)
                const authToken = this.$apiAuth.getAuthToken()
                postCoordsToImages(authToken, this._imgMixinIdProcessing, json_str_coords)
                .then((res) => {
                  console.log('JSON com coordenadas das imagens foi enviada com sucesso!')
                  this.imgCoords = res.data.data.images_coords
                  this.dialog2 = true
                })          
                this.loader.hide();               
              })
              .catch((error) => {
                this.loadImgCoords = false
                this.loader.hide();
                console.log(`Erro nas promises ${error}`)
              }) 
            } else {
              this.loadImgCoords = false
              this.$notify(new NotificationOptions({
                message: "Seu arquivo .zip parece estar vazio.",
                type: NOTIFICATION_TYPES.WARNING,
              }))
            }                     
          } else {
            console.log("Not .zip")
            const listCoordsImages = await new Promise((resolve, reject) => { 
              try {
                let tempArrayCoords = [] 
                for (let index = 0; index < this.toUploadImages.length; index++) {
                  const tags = new Promise((resolve, reject) => {               
                    EXIF.getData(this.toUploadImages[index], function(err, tags) { 
                        
                        window.decimalCoords = function(coords, ref) {
                          let decimal_degrees = coords[0] + coords[1] / 60 + coords[2] / 3600
                          if (ref == "S" || ref == "W"){
                              decimal_degrees = -decimal_degrees
                          }
                          return decimal_degrees
                        }                       
                        if (err) reject(err);
                        else {
                          let latitude = window.decimalCoords(this.exifdata.GPSLatitude, this.exifdata.GPSLatitudeRef)
                          let longitude = window.decimalCoords(this.exifdata.GPSLongitude, this.exifdata.GPSLongitudeRef)
                          let altitude = this.exifdata.GPSAltitude
                          tags = {'imagem': this.name, 'longitude':longitude, 'latitude': latitude, 'altitude': altitude}
                          resolve(tags);
                        }
                    });
                  }); 
                  tempArrayCoords.push(tags)               
                }
                resolve(tempArrayCoords)
              } catch (error) {
                console.error(error);
                reject(error)
              }        
            })
            Promise.all(listCoordsImages).then((values) => {        
              let json_str_coords = JSON.stringify(values)
              console.log('JSON_ARRAY_COORDS >> ', json_str_coords)
              const authToken = this.$apiAuth.getAuthToken()
              postCoordsToImages(authToken, this._imgMixinIdProcessing, json_str_coords)
              .then((res) => {
                console.log('JSON com coordenadas das imagens foi enviada com sucesso!')
                this.imgCoords = res.data.data.images_coords
                this.dialog2 = true
              })
              this.loader.hide();
              console.log(' <<<<<<<<<<< AFTER ARRAY_COORDS >>>>>>>>>>> ')   
            });          
          }          
        } catch (error) {
          console.log("ERROR GERAL >>>> ", error)
          this.loadImgCoords = false
          this.loader.hide();
        }
      },
      onDragEnter() {
        if (!this.canUpload) return
        this.isDragging = true
      },
      onDragExit() {
        if (!this.isFirefox && !this.isOtherBrowser) return

        if (!this.canUpload) return
        this.isDragging = false
      },
      onDragOver(event) {
        event.preventDefault()
      },
      onDragLeave() {
        if (!this.canUpload) return
        this.isDragging = false
      },

      // Paginação para as imagens
      nextPage() {
        if (this.currPageIdx >= this.maxPage - 1) return
        this.currPageIdx++
      },
      lastPage() {
        if (this.currPageIdx - 1 < 0) return
        this.currPageIdx--
      },
      setPage(idx) {
        if (isUndefined(idx) || isNull(idx) || idx >= this.maxPage || idx < 0) return
        this.currPageIdx = idx
      },

      // Helpers
      getFilesFromDataTransfer(dataTransfer) {
        const addedFiles = []
        for (const item of dataTransfer.items) {
          if (item.kind !== "file") {
            continue
          }

          addedFiles.push(item.getAsFile())
        }

        return addedFiles
      },
      checkImageUploadFinished(img) {
        return img.uploadCompleted && gte(img.uploadProgress, 100)
      },
      startUpload() {
        if (this.isFlightLogUploaded == false && this.$store.state.processing.processingData.ab_georeference_type == 'LAT_LONG') {
          this.$notify(new NotificationOptions({
            message: "Faça o upload do log de voo.",
            type: NOTIFICATION_TYPES.WARNING,
          }))
          return
        } else {
          const template = this.$store.state.processing.processingData.ab_processing_template
          this.startUploadImages(template)
        }
      },
      onZipError(content, qttData) {
        this.isUploadingImages = false
        this.toUploadImages = []
        if (content != "error") {
          this.qttData = qttData
          this.issueDialog = true
          this.issueContent = content
        }
      },
      onZipReadError(val) {
        this.zipReadError = val
      },
      onStepEnter(step) {
        if (!isEqual(step, PROCESSING_STEPS.UPLOAD)) return
        if (!this._idProcessing) this.SetStep(PROCESSING_STEPS.BASIC)
        if (this.mustShowAutoProcessing) this.mustStartProcessingOnFinish = true

        this.isLoadingImages = true
        const nonUploadedImages = this.nonUploadedFiles(this._idProcessing)
        if (!this.isUploadingImages && !isEmpty(nonUploadedImages)) {
          const filesName = nonUploadedImages.map(fileName => "- " + fileName).join("<br>")
          let title = `Desde a ultima sessão ${nonUploadedImages.length} imagens não foram adicionadas:`
          let prefix3=nonUploadedImages[0].substr(nonUploadedImages[0].length-3,nonUploadedImages[0].length)
          if(prefix3=="zip"){
            title="Seu arquivo Compactado não foi enviado completamente desde a ultima tentativa de upload. Selecione ele novamente:"
            //Seu arquivo .zip não foi enviado completamente desde a ultima tentativa de upload. Selecione ele novamente para upload e ele vai recomeçar de onde parou.
          }
          this.$dialog(new DialogOptions({
            title: title,
            content: `${filesName}`,
            confirmText: "Entendi",
            type: DIALOG_TYPES.ALERT,
          }))
          this.setNonUploadedFiles({processingId: this._idProcessing, fileList: []})
        }

        const authToken = this.$apiAuth.getAuthToken()
        listUploadedImages(authToken, this._idProcessing)
          .then((res) => {
            const loadedFiles = res.data.data.files
            this.uploadedImages = loadedFiles.map((obj) => {
              const nameSplit = obj.name.split("/")
              const fileName = nameSplit[nameSplit.length - 1]

              const uploaderFileHolder = new UploadFileHolder({name: fileName, size: obj.size})
              uploaderFileHolder.uploadProgress = 100
              uploaderFileHolder.uploadCompleted = true
              return uploaderFileHolder
            })

            if (this.uploadedImages.length > 0) this.imagesUploadProgress = 100
            this.isLoadingImages = false
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Erro ao carregar imagens upadas, atualize a página.",
              type: NOTIFICATION_TYPES.WARNING,
            }))
            this.isLoadingImages = false
          })

        getUploadedFlightLog(authToken, this._idProcessing)
          .then((res) => {
            const flightLogs = res.data.data.files

            if (isEmpty(flightLogs)) return

            this.flightLogFile = new UploadFileHolder({name: "Log de voo upado", size: flightLogs[0].size})
            this.isFlightLogUploaded = true
            this.flightLogUploadProgress = 100

            this.flightLogInput = new File([], this.flightLogFile.name)
          })

        getUploadedGcp(authToken, this._idProcessing)
          .then((res) => {
            const gcps = res.data.data.files

            if (isEmpty(gcps)) return

            this.gcpFile = new UploadFileHolder({name: "Ponto de controle upado", size: gcps[0].size})
            this.isGcpUploaded = true
            this.gcpUploadProgress = 100

            this.gcpInput = new File([], this.gcpFile.name)
          })
      },
      ...mapActions({
        setNonUploadedFiles: SET_NON_UPLOADED_FILES,
        removeNonUploadedFile: REMOVE_NON_UPLOADED_FILE,
      }),
    },
    filters: {
      getCurrImgProgress(img) {
        return img.uploadProgress ? Math.trunc(img.getUploadProgress()) : 0
      },
    },
    computed: {
      minLengthImages() {
        if (this.processingTypeIsFP) {
          if (!this.toUploadImages[0].isZip){
            return this.fullImagesList.length < 8
          } else {
            return false
          }            
        } else {
          return false
        }
      },
      uploadedImagesError() {
        let error = null
        if (!this.$v.uploadedImages.$dirty) return error
        let errDesc = ""
        if (this.processingTypeIsFP) errDesc = "Apenas é possível criar um processamento do tipo 'Imagens de Drone' com mais de 8 imagens ou um Arquivo Compactado."
        else errDesc = "Apenas é possível criar um processamento do tipo 'Ortomosaico' com uma imagem."
        !this.$v.uploadedImages.minLength && (error = errDesc)
        return error
      },
      isFlightLogUploadedError() {
        let error = null
        if (!this.$v.isFlightLogUploaded.$dirty) return error
        !this.$v.isFlightLogUploaded.complete && (error = "É necessário fazer o upload do log de voo para continuar")
        return error
      },
      isGcpUploadedError() {
        let error = null
        if (!this.$v.isGcpUploaded.$dirty) return error
        !this.$v.isGcpUploaded.complete && (error = "É necessário fazer o upload do gcp para continuar")
        return error
      },
      maxPage() {
        return Math.ceil(this.fullImagesList.length / this.imagesPerPage)
      },
      currImagesPage() {
        const initIndex = this.currPageIdx * this.imagesPerPage
        return this.fullImagesList.slice(initIndex, initIndex + this.imagesPerPage)
      },
      canUpload() {
        return !(this.isUploadingImages || this.isLoadingImages || this._processingIsReadOnly)
      },
      processingTypeIsFP() {
        if (isEmpty(this._processingData))
          return false
        return isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.FULL_PROCESSING)
      },
      processingTypeIsTilling() {
        if (isEmpty(this._processingData))
          return false
        return isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.TILLING)
      },
      isMultispectral() {
        return this._processingData && isEqual(this._processingData["ab_camera_type"], CAMERA_TYPES.MULTISPECTRAL)
      },
      hasFlightLog() {
        if (!this._processingData)
          return false
        return (
          isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.FULL_PROCESSING)
          && !isEqual(this._processingData["ab_georeference_type"], GEOREFERENCE_TYPES.NOT_SET)
        )
      },
      hasGcp() {
        if (!this._processingData)
          return false
        return (
          isEqual(this._processingData["ab_processing_type"], PROCESSING_TYPES.FULL_PROCESSING)
          && this._processingData["bl_gcp"]
        )
      },
      imageInputDescription() {
        if (isEmpty(this._processingData))
          return null
        if (this.isMultispectral || this.processingTypeIsTilling)
          return "Arraste ou clique para adicionar imagens do tipo .tif, .jpeg"
        else
          return "Arraste ou clique para adicionar imagens do tipo .png, .jpg ou .zip"
      },
      flightLogInputLabel() {
        if (isEmpty(this._processingData))
          return null
        if (!this.hasFlightLog)
          return null
        if (isEqual(this._processingData["ab_georeference_type"], GEOREFERENCE_TYPES.THREE_D_ROBOTICS))
          return "Clique aqui e insira um arquivo do tipo .log"
        else
          return "Clique aqui e insira um arquivo do tipo .txt"
      },
      isZipFileSelected() {
        if(!isEmpty(this.toUploadImages)) {
          return this.toUploadImages[0].isZip
        } else {
          return false
        }        
      },
      isUploadFinished() {
        return !(
          (this.isUploadingImages || this.isUploadingFlightLog || this.isUploadingGcp) ||
          (this.isLoadingImages || this.uploadedImages.length === 0) ||
          (this.hasFlightLog && !this.isFlightLogUploaded) ||
          (this.hasGcp && !this.isGcpUploaded) ||
          !isEmpty(this.toUploadImages)
        )
      },
      mustShowAutoProcessing() {
        return !(this.$subsMng.subscriptionPlanConfig["bl_charge_processing"]) && !(this.hasGcp && this.$subsMng.subscriptionPlanConfig["bl_charge_gcp"])
      },
      isFirefox() {
        return typeof InstallTrigger !== 'undefined';
      },
      isChrome() {
        return !!window.chrome && (!!window.chrome["webstore"] || !!window.chrome["runtime"])
      },
      isOtherBrowser() {
        return !this.isFirefox && !this.isChrome
      },

      nextPageIsDisabled() {
        return gte(this.currPageIdx, (this.maxPage - 1))
      },
      ...mapGetters({
        nonUploadedFiles: GET_NON_UPLOADED_FILES,
        _idProcessing: GET_ID_PROCESSING,
        _processingData: GET_PROCESSING_DATA,
        _processingIsReadOnly: GET_PROCESSING_IS_READ_ONLY,
      }),
    },
    mounted() {
      ProcessingStepperEventBus.$on("step-change", this.onStepEnter)
      UploaderEventBus.$on("change-page", this.setPage)
      UploaderEventBus.$on("upload-finished", this.onUploadFinished)
      UploaderEventBus.$on("zip-error", this.onZipError)
      UploaderEventBus.$on("zip-read-error", this.onZipReadError)
    },
    beforeDestroy() {
      ProcessingStepperEventBus.$off("step-change", this.onStepEnter)
      UploaderEventBus.$off("change-page", this.setPage)
      UploaderEventBus.$off("upload-finished", this.onUploadFinished)
      if (this.retrySetTimeout) {
        clearTimeout(this.retrySetTimeout)
      }
    }
  }
</script>

<style scoped lang="scss">

  .image-input {
    display: none;
  }

  .image-card {
    .delete-image-btn {
      top: 0 !important;
      right: 0 !important;
      transform: translate(50%, -50%) scale(0) !important;
      transition: transform 250ms cubic-bezier(0.19, 1, 0.22, 1) !important;
    }

    &:hover {
      .delete-image-btn {
        transform: translate(50%, -50%) scale(1) !important;
      }
    }
  }

  .actions {
    .v-btn {
      margin: 0 5px;
    }
  }

  .fade-enter-active {
    transition: transform .2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .fade-leave-active {
    transition: transform .2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    transform: scale(0);
  }

  .error-enter-active, .error-leave-active {
    transition: all 150ms ease-in;
  }

  .error-enter, .error-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to {
    opacity: 0.4;
    transform: translateX(100%);
  }

  .upload-progress__text {
    font-size: 10px;
  }

  .dropzone {
    * {
      pointer-events: none !important;
    }
  }

</style>
